import { Instagram, Facebook, Linkedin, MessageCircle, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    { icon: Instagram, href: 'https://instagram.com/broadwaytech', label: 'Instagram' },
    { icon: Facebook, href: 'https://facebook.com/broadwaytech', label: 'Facebook' },
    { icon: Linkedin, href: 'https://linkedin.com/company/broadwaytech', label: 'LinkedIn' },
    { icon: MessageCircle, href: 'https://wa.me/919876543210', label: 'WhatsApp' },
  ];

  const footerLinks = [
    {
      title: 'Services',
      links: [
        { name: 'Web Development', href: '#services' },
        { name: 'Mobile Apps', href: '#services' },
        { name: 'Backend & APIs', href: '#services' },
        { name: 'UI/UX Design', href: '#services' },
      ],
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', href: '#about' },
        { name: 'Our Work', href: '#projects' },
        { name: 'Contact', href: '#contact' },
      ],
    },
  ];

  return (
    <footer 
      className="relative bg-slate-950 border-t border-slate-800"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a href="#hero" className="flex items-center gap-2 mb-6" data-testid="footer-logo">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center font-space font-bold text-white text-lg">
                B
              </div>
              <span className="font-space font-bold text-xl tracking-tighter text-white">
                Broadway<span className="text-blue-500">Tech</span>
              </span>
            </a>
            <p className="text-slate-500 max-w-sm mb-6 leading-relaxed">
              Building scalable digital solutions for modern businesses. Your trusted partner 
              in software development and digital transformation.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-3" data-testid="footer-social-links">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-500 hover:text-blue-400 hover:border-blue-500/50 transition-all duration-300"
                  aria-label={social.label}
                  data-testid={`footer-social-${social.label.toLowerCase()}`}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((section, index) => (
            <div key={index}>
              <h4 className="font-space font-semibold text-white mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-slate-500 hover:text-blue-400 transition-colors text-sm"
                      data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-slate-800">
          <p className="text-sm text-slate-600" data-testid="footer-copyright">
            © {new Date().getFullYear()} Broadway Tech Solutions. All rights reserved.
          </p>
          
          {/* Back to top */}
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-sm text-slate-500 hover:text-blue-400 transition-colors"
            data-testid="footer-back-to-top"
          >
            Back to top
            <ArrowUp size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
